export default __webpack_public_path__ + "static/media/remove_minus_icon.56e2806c.svg";